var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransakLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "269 324.157 430.831 430.733",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 297.72,
    y1: 432.94,
    x2: 669.52,
    y2: 647.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#348bed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2b80e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1461db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0e57d7"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#1461db;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 483.62,
    cy: 540.27,
    r: 214.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.14,527.15l-60.62-60.62h0l-.11-.11-.24-.21a15.17,15.17,0,0,0-1.23-1c-.3-.24-.6-.47-.92-.68-.14-.1-.28-.18-.43-.27a16.46,16.46,0,0,0-22,3.65l-94.28,94.29v-84a16.65,16.65,0,0,0-33.3,0v84l-34.42-34.42a16.65,16.65,0,0,0-23.54,23.54l62.84,62.84a14.82,14.82,0,0,0,1.25,1.13c.42.34.86.67,1.3,1l0,0A16.65,16.65,0,0,0,421,618.9h.07c.54.05,1.08.08,1.62.08h0l.25,0q.68,0,1.35-.06l.33,0c.43-.05.86-.1,1.28-.19l.19,0c.47-.1.94-.21,1.4-.35l.08,0a15.32,15.32,0,0,0,1.48-.53h0a15.62,15.62,0,0,0,2-1l.38-.22a15.91,15.91,0,0,0,1.8-1.28l.17-.15c.35-.3.7-.6,1-.94L530,518.6v83.74a16.65,16.65,0,0,0,33.3,0v-84L595.6,550.7a16.65,16.65,0,0,0,23.54-23.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransakLogo);
export default __webpack_public_path__ + "static/media/transak-logo.bf97f47624d2e33a0ddab6cd6bfa2ee6.svg";
export { ForwardRef as ReactComponent };